import * as React from 'react'
import { Props } from './types'
// @ts-ignore
import ICON_NO_DATE from '../../assets/no-data-image.svg'

import './styles.scss'

export class NoData extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div className="noData">
        <div className="doubleBlock">
          <div className="imageBlock">
            <ICON_NO_DATE />
          </div>
          <div className="emptyImage" />
        </div>
        <div className="textBlock">
          <div className="title">
            Aucune donnée
          </div>
          <div className="description">
            Aucune donnée à afficher
          </div>
        </div>
      </div>
    )
  }
}
